/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordstrengthchecking2Inputs */

const en_passwordstrengthchecking2 = /** @type {(inputs: Passwordstrengthchecking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking...`)
};

const de_passwordstrengthchecking2 = /** @type {(inputs: Passwordstrengthchecking2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfe…`)
};

/**
* | output |
* | --- |
* | "Checking..." |
*
* @param {Passwordstrengthchecking2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordstrengthchecking2 = /** @type {((inputs?: Passwordstrengthchecking2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordstrengthchecking2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordstrengthchecking2(inputs)
	return de_passwordstrengthchecking2(inputs)
});
export { passwordstrengthchecking2 as "passwordStrengthChecking" }